<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
        <g :fill="color" fill-rule="nonzero">
            <path d="M6.316 5.714h1.579v.715h-1.58z"/>
            <path d="M15 6.155v-.919h-4.338V3.947l-2.667-.884v-.407h2.242V.49H7.995V0h-.98V3.063l-2.667.884v1.29H0v.918h.432v7.927H0V15H15v-.918h-.422V6.155H15zM4.348 14.082H1.411V6.155h2.937v7.927zm3.659 0H7.004v-2.847h1.003v2.847zm1.676-8.846v8.846h-.697v-3.766H6.025v3.766h-.698V4.596l2.178-.721 2.178.722v.64zm.98 8.846V6.155h2.936v7.927h-2.937zM7.95 1.125h1.725v.75H7.95v-.75z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "OnsiteIcon",
        props: {
            isDarker: {
                type: Boolean,
                default() {
                    return false;
                },
            },
            color: {
                type: String,
                default() {
                    return this.isDarker ? '#263238' : '#ABABAB';
                },
            },
        },
    }
</script>

<style scoped>

</style>
